<app-form-group *ngIf="query" [formGroup]="root">
    <label for="optionSelector" class="text-standard">{{query.query}}</label>
    <select id="optionSelector" [attr.data-test-id]="'optionSelector-' + queryIndex"
        class="skv-form-control icon-dropdown-arrow" formControlName="option">
        <option value="">Välj</option>
        <option *ngFor="let opt of query.options" [value]="opt.text" [ngValue]="opt.text">{{opt.text}}</option>
    </select>
</app-form-group>
<app-navigation-query *ngIf="selectedOption && selectedOption.next" [query]="selectedOption.next"
    [queryIndex]="queryIndex + 1">
</app-navigation-query>
<p *ngIf="selectedOption && selectedOption.link && selectedOption.link.description">{{selectedOption.link.description}}
</p>
<app-form-group *ngIf="selectedOption && selectedOption.link">
    <app-link external="true" [href]="selectedOption.link.url" [attr.data-test-id]="'link-' + (queryIndex+1)">
        {{selectedOption.link.label}}</app-link>
</app-form-group>